import { useDataSpacesApi} from "../../Hooks/useDataSpacesApi";
// eslint-disable-next-line import/no-extraneous-dependencies
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-extraneous-dependencies
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { SpaceCrud } from "../../components/spaces/space";

/**
 * 
 * @const Spaces displays the complete week for the reservation page
 * @returns {JSX.Element} HTML content
 */

const Spaces = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const spaces = useDataSpacesApi();

    return (
        <div className="bg-white overflow-x-auto flex flex-col gap-6 bg-white shadow-lg rounded-lg p-8">
            {
                <div className="flex justify-between">
                    <h2 className="text-2xl font-semibold py-2 px-4"> 
                        Liste des espaces
                    </h2>
                    <Link to="/add-space">
                        <button
                            disabled={spaces === undefined}
                            className={`${spaces === undefined ? "animate-pulse bg-gray-300 p-5 rounded mt-2 disabled:cursor-not-allowed" : "rounded mt-2 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4"}`}
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        >
                            {spaces === undefined ? <>   </> : (
                                <>
                                    <FontAwesomeIcon icon={faPlus} className="mr-2" /> Ajouter un Espace
                                </>
                            )}
                        </button>
                    </Link>
                </div>
            }
            <table className="w-full table-auto">
                <thead>
                    <tr className="text-left">
                        <th className="p-4">Nom</th>
                        <th className="p-4">Code Postal</th>
                        <th className="p-4">Ville</th>
                        <th className="p-4">Nb Places</th>
                    </tr>
                </thead>
                <tbody className="w-full">
                    {spaces === undefined ? (
                        <tr>
                            <td colSpan={7} className="text-center p-4">Chargement...</td>
                        </tr>
                    ) : (
                        spaces.map((space) => (
                            <SpaceCrud
                                key={space.id}
                                {...space}
                            />
                        ))
                    )}
                </tbody>
            </table>
        </div>

    );

}
export { Spaces };